/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { StoreAddress } from './StoreAddress';
// @ts-ignore
import {
// @ts-ignore
    StoreAddressFromJSON,
// @ts-ignore
    StoreAddressFromJSONTyped,
// @ts-ignore
    StoreAddressToJSON,
} from './StoreAddress';
// @ts-ignore
import type { StoreOrderPrediction } from './StoreOrderPrediction';
// @ts-ignore
import {
// @ts-ignore
    StoreOrderPredictionFromJSON,
// @ts-ignore
    StoreOrderPredictionFromJSONTyped,
// @ts-ignore
    StoreOrderPredictionToJSON,
} from './StoreOrderPrediction';
// @ts-ignore
import type { StoreReceivingWindow } from './StoreReceivingWindow';
// @ts-ignore
import {
// @ts-ignore
    StoreReceivingWindowFromJSON,
// @ts-ignore
    StoreReceivingWindowFromJSONTyped,
// @ts-ignore
    StoreReceivingWindowToJSON,
} from './StoreReceivingWindow';

/**
 * 
 * @export
 * @interface StoreCreateRequest
 */
export interface StoreCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreCreateRequest
     */
    retailerId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreCreateRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreCreateRequest
     */
    externalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreCreateRequest
     */
    contactCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreCreateRequest
     */
    contactNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreCreateRequest
     */
    currencyCode?: string;
    /**
     * 
     * @type {Array<StoreAddress>}
     * @memberof StoreCreateRequest
     */
    addresses?: Array<StoreAddress>;
    /**
     * 
     * @type {boolean}
     * @memberof StoreCreateRequest
     */
    showVat?: boolean;
    /**
     * 
     * @type {Array<StoreReceivingWindow>}
     * @memberof StoreCreateRequest
     */
    receivingWindows?: Array<StoreReceivingWindow>;
    /**
     * 
     * @type {StoreOrderPrediction}
     * @memberof StoreCreateRequest
     */
    orderPrediction?: StoreOrderPrediction;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof StoreCreateRequest
     */
    customData?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof StoreCreateRequest
     */
    dynamicFields?: { [key: string]: string; };
}

/**
 * Check if a given object implements the StoreCreateRequest interface.
 */
// @ts-ignore
export function instanceOfStoreCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

// @ts-ignore
export function StoreCreateRequestFromJSON(json: any): StoreCreateRequest {
    return StoreCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retailerId': !exists(json, 'retailer_id') ? undefined : json['retailer_id'],
        'name': json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'contactCountryCode': !exists(json, 'contact_country_code') ? undefined : json['contact_country_code'],
        'contactNumber': !exists(json, 'contact_number') ? undefined : json['contact_number'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'currencyCode': !exists(json, 'currency_code') ? undefined : json['currency_code'],
        'addresses': !exists(json, 'addresses') ? undefined : ((json['addresses'] as Array<any>).map(StoreAddressFromJSON)),
        'showVat': !exists(json, 'show_vat') ? undefined : json['show_vat'],
        'receivingWindows': !exists(json, 'receiving_windows') ? undefined : ((json['receiving_windows'] as Array<any>).map(StoreReceivingWindowFromJSON)),
        'orderPrediction': !exists(json, 'order_prediction') ? undefined : StoreOrderPredictionFromJSON(json['order_prediction']),
        'customData': !exists(json, 'custom_data') ? undefined : json['custom_data'],
        'dynamicFields': !exists(json, 'dynamic_fields') ? undefined : json['dynamic_fields'],
    };
}

// @ts-ignore
export function StoreCreateRequestToJSON(value?: StoreCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retailer_id': value.retailerId,
        'name': value.name,
        'email': value.email,
        'external_code': value.externalCode,
        'contact_country_code': value.contactCountryCode,
        'contact_number': value.contactNumber,
        'description': value.description,
        'currency_code': value.currencyCode,
        'addresses': value.addresses === undefined ? undefined : ((value.addresses as Array<any>).map(StoreAddressToJSON)),
        'show_vat': value.showVat,
        'receiving_windows': value.receivingWindows === undefined ? undefined : ((value.receivingWindows as Array<any>).map(StoreReceivingWindowToJSON)),
        'order_prediction': StoreOrderPredictionToJSON(value.orderPrediction),
        'custom_data': value.customData,
        'dynamic_fields': value.dynamicFields,
    };
}

